import React from 'react';
import classes from './ContentBox.module.scss';

const ContentBox = ({ style, content, additionalClasses }) => {
  return (
    <div className={`${classes.contentBox} ${additionalClasses}`} style={style}>
      {content}
    </div>
  );
};

export default ContentBox;
